module.exports = __webpack_public_path__ + "static/media/notes.a242ab6e.svg";